import { DurationFormatter } from "@/v2/components/formatters/DurationFromatter";

export function TimeToResolutionFormatter({
  value,
  shorthand = false,
}: {
  value: number;
  shorthand?: boolean;
}) {
  return <DurationFormatter value={value * 60} shorthand={shorthand} />;
}
